import { Rating } from "@mui/material";
import moment from "moment";

export default function DocumentReviewItem({ data }) {
    return <div className="mb-7">
        <div className="flex items-center gap-3">
            <Rating value={data.rating} readOnly />
            <i className="text-gray-400">{moment(data.createDate).local().format("YYYY-MM-DD")}</i>
        </div>
        <p>{data.text}</p>
        <br />
        <hr />
    </div>
}